import React from "react";

interface LogoProps {
  className?: string;
  size?: number;
}

export const WealthBeeLogo: React.FC<LogoProps> = ({ className, size = 40 }) => {
  return (
    <img src={"https://cdn.wealthbee.io/main/logos/wealthbee-logo-only.svg"} alt="WealthBee Logo" className={className} width={size} height={size} />
  );
}; 